/*
  <delivery-area> — "Deliver to" in the cart (snippets/delivery-area.liquid).

  Shopify's checkout cannot take custom fields on this plan, but a cart can
  carry a delivery address that checkout opens with. So the choice made here is
  written onto the shopper's cart with the Storefront API
  (cartDeliveryAddressesReplace, tokenless access on the shop's own domain) and
  checkout opens with it filled in; the shopper can still change anything.

    Signed-in customer with saved addresses: pick one (default preselected) and
      the whole address goes to checkout, or choose "Add a new address".
    New address / guest: Governorate + Area dropdowns (assets/egypt-areas.js);
      checkout opens with those two filled in.

  A choice is required before checkout ("Other area" counts). Only the choice
  (address id, or governorate + area) is kept in localStorage, never the
  address itself; saved addresses are re-read from Liquid on every render.
*/
(function () {
  'use strict';
  if (window.__deliveryAreaInit) return;   // cart page and drawer may both load this
  window.__deliveryAreaInit = true;
  var KEY = 'gt:deliveryArea';
  var API = '/api/2026-07/graphql.json';
  var REPLACE = 'mutation($id:ID!,$a:[CartSelectableAddressInput!]!){cartDeliveryAddressesReplace(cartId:$id,addresses:$a){userErrors{message}}}';
  var ar = /^ar/i.test(document.documentElement.lang || '');
  var T = ar
    ? { title: 'التوصيل إلى', gov: 'المحافظة', area: 'المنطقة', pickGov: 'اختر المحافظة', pickArea: 'اختر المنطقة',
        first: 'اختر المحافظة أولاً', other: 'منطقة أخرى', newAddr: 'إضافة عنوان جديد', manage: 'إدارة العناوين',
        need: 'من فضلك اختر عنوان التوصيل قبل إتمام الطلب.', hint: 'سنملأ المحافظة والمنطقة لك في صفحة الدفع.',
        hintSaved: 'سيظهر هذا العنوان كاملاً في صفحة الدفع.', saved: 'تم الحفظ لصفحة الدفع ✓',
        labels: { home: 'المنزل', work: 'العمل', other: 'أخرى' }, def: 'افتراضي' }
    : { title: 'Deliver to', gov: 'Governorate', area: 'Area', pickGov: 'Select governorate', pickArea: 'Select area',
        first: 'Select governorate first', other: 'Other area', newAddr: 'Add a new address', manage: 'Manage addresses',
        need: 'Please choose where to deliver before checkout.', hint: 'We will fill in governorate and area for you at checkout.',
        hintSaved: 'This address will be filled in at checkout.', saved: 'Saved for checkout ✓',
        labels: { home: 'Home', work: 'Work', other: 'Other' }, def: 'Default' };

  var BOOK = {};   // saved addresses by id, from the last rendered box

  function load() { try { return JSON.parse(localStorage.getItem(KEY)) || {}; } catch (e) { return {}; } }
  function save(v) { try { localStorage.setItem(KEY, JSON.stringify(v)); } catch (e) {} }
  function esc(v) {
    return String(v == null ? '' : v).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; });
  }
  function parse(v, fallback) { try { return JSON.parse(v); } catch (e) { return fallback; } }

  function isComplete(p) {
    if (!p) return false;
    if (p.mode === 'saved') return !!BOOK[p.id];
    return !!(p.zone && (p.city || p.other));
  }

  // The address sent to checkout for a choice.
  function toCartAddress(p) {
    if (p.mode === 'saved') {
      var a = BOOK[p.id];
      if (!a) return null;
      var out = { countryCode: a.country || 'EG' };
      if (a.zone) out.provinceCode = a.zone;
      [['first', 'firstName'], ['last', 'lastName'], ['address1', 'address1'], ['address2', 'address2'],
       ['city', 'city'], ['zip', 'zip'], ['phone', 'phone']].forEach(function (m) { if (a[m[0]]) out[m[1]] = a[m[0]]; });
      return out;
    }
    if (!p.zone) return null;
    var n = { countryCode: 'EG', provinceCode: p.zone };
    if (p.city) n.city = p.city;
    return n;
  }

  var lastApplied = '';
  async function apply(pick) {
    var addr = pick && toCartAddress(pick);
    if (!addr) return;
    var cart = await fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
    if (!cart || !cart.token) return;
    var sig = cart.token + '|' + JSON.stringify(addr);
    if (sig === lastApplied) return;
    var res = await fetch(API, {
      method: 'POST', headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: REPLACE, variables: {
        id: 'gid://shopify/Cart/' + cart.token,
        a: [{ address: { deliveryAddress: addr }, selected: true, oneTimeUse: true }]
      } })
    }).then(function (r) { return r.json(); });
    var errs = res && res.data && res.data.cartDeliveryAddressesReplace && res.data.cartDeliveryAddressesReplace.userErrors;
    if (!res.errors && !(errs && errs.length)) lastApplied = sig;
  }

  // Area and governorate are stored in English; show them in Arabic on /ar
  // using the same lists as the dropdowns. Anything typed by hand stays as is.
  function arArea(zone, city) {
    var list = (window.EGYPT_AREAS && window.EGYPT_AREAS[zone]) || [];
    var c = String(city || '').toLowerCase();
    for (var i = 0; i < list.length; i++) if (list[i][0].toLowerCase() === c) return list[i][1];
    return city;
  }
  function addressLine(a) {
    var city = a.city, prov = a.province;
    if (ar) {
      city = arArea(a.zone, a.city);
      prov = (window.EGYPT_ZONES_AR && window.EGYPT_ZONES_AR[a.zone]) || a.province;
    }
    return [a.address1, a.address2, city, prov].filter(Boolean).join(ar ? '، ' : ', ');
  }

  class DeliveryArea extends HTMLElement {
    connectedCallback() {
      if (!window.EGYPT_AREAS || !window.EGYPT_ZONES_EN) return;
      var self = this;
      var book = parse(this.getAttribute('data-addresses') || '[]', []) || [];
      var labels = parse(this.getAttribute('data-labels') || 'null', null) || {};
      var defId = String(this.getAttribute('data-default') || '');
      BOOK = {};
      book.forEach(function (a) { BOOK[String(a.id)] = a; });
      book.sort(function (a, b) { return (String(b.id) === defId) - (String(a.id) === defId); });

      var pick = load();
      // Default: the customer's default address; a stale saved id falls back too.
      if (book.length && (!pick.mode || (pick.mode === 'saved' && !BOOK[pick.id]))) {
        pick = { mode: 'saved', id: defId && BOOK[defId] ? defId : String(book[0].id) };
        save(pick);
      }
      if (!book.length && pick.mode === 'saved') pick = {};

      var names = ar && window.EGYPT_ZONES_AR ? window.EGYPT_ZONES_AR : window.EGYPT_ZONES_EN;
      var zones = Object.keys(window.EGYPT_ZONES_EN).sort(function (a, b) {
        return String(names[a]).localeCompare(String(names[b]), ar ? 'ar' : 'en');
      });
      var picker =
        '<div class="delivery-area__row" data-da-new>' +
          '<label class="delivery-area__field"><span>' + T.gov + '</span><select data-da-zone>' +
            '<option value="">' + T.pickGov + '</option>' +
            zones.map(function (z) { return '<option value="' + z + '"' + (pick.mode !== 'saved' && pick.zone === z ? ' selected' : '') + '>' + esc(names[z]) + '</option>'; }).join('') +
          '</select></label>' +
          '<label class="delivery-area__field"><span>' + T.area + '</span><select data-da-area></select></label>' +
        '</div>';

      // Unique radio group per box: the cart page and the drawer can both be in
      // the document, and a shared name would let one untick the other.
      var group = 'da-choice-' + (++DeliveryArea.count);
      this.group = group;
      var list = '';
      if (book.length) {
        list = '<div class="delivery-area__book" role="radiogroup" aria-label="' + T.title + '">' +
          book.map(function (a) {
            var id = String(a.id);
            var lab = labels['gid://shopify/CustomerAddress/' + id];
            var tag = lab && T.labels[lab] ? '<em class="delivery-area__tag">' + T.labels[lab] + '</em>' : '';
            var def = id === defId ? '<em class="delivery-area__tag delivery-area__tag--def">' + T.def + '</em>' : '';
            return '<label class="delivery-area__opt"><input type="radio" name="' + group + '" value="' + esc(id) + '"' +
              (pick.mode === 'saved' && pick.id === id ? ' checked' : '') + '>' +
              '<span class="delivery-area__optbody"><span class="delivery-area__name">' + tag + def + esc([a.first, a.last].filter(Boolean).join(' ')) + '</span>' +
              '<span class="delivery-area__line">' + esc(addressLine(a)) + '</span>' +
              (a.phone ? '<span class="delivery-area__line">' + esc(a.phone) + '</span>' : '') + '</span></label>';
          }).join('') +
          '<label class="delivery-area__opt delivery-area__opt--new"><input type="radio" name="' + group + '" value="__new"' +
            (pick.mode !== 'saved' ? ' checked' : '') + '><span class="delivery-area__optbody"><span class="delivery-area__name">+ ' + T.newAddr + '</span></span></label>' +
        '</div>';
      }

      this.innerHTML =
        '<p class="delivery-area__title">' + T.title +
          (book.length ? ' <a class="delivery-area__manage" href="' + esc(this.getAttribute('data-account-url') || '/account') + '">' + T.manage + '</a>' : '') + '</p>' +
        list + picker +
        '<p class="delivery-area__hint" data-da-hint></p>';
      this.zoneSel = this.querySelector('[data-da-zone]');
      this.areaSel = this.querySelector('[data-da-area]');
      this.newBox = this.querySelector('[data-da-new]');
      this.fillAreas(pick.mode !== 'saved' ? (pick.other ? '__other' : pick.city) : '');
      this.syncMode(pick);

      this.zoneSel.addEventListener('change', function () { self.fillAreas(''); self.commitNew(); });
      this.areaSel.addEventListener('change', function () { self.commitNew(); });
      this.addEventListener('change', function (e) {
        if (e.target.name !== self.group) return;
        if (e.target.value === '__new') { self.commitNew(); }
        else { var p = { mode: 'saved', id: e.target.value }; save(p); self.syncMode(p); self.push(p); }
      });
      if (isComplete(pick)) apply(pick).catch(function () {});
    }

    syncMode(p) {
      var saved = p.mode === 'saved';
      this.newBox.hidden = saved;
      var hint = this.querySelector('[data-da-hint]');
      if (hint) hint.textContent = saved ? T.hintSaved : T.hint;
      if (isComplete(p)) this.classList.remove('is-invalid');
    }

    fillAreas(current) {
      var z = this.zoneSel.value;
      var list = (window.EGYPT_AREAS[z] || []).slice();
      if (ar) list.sort(function (a, b) { return a[1].localeCompare(b[1], 'ar'); });
      this.areaSel.disabled = !z;
      this.areaSel.innerHTML = '<option value="">' + (z ? T.pickArea : T.first) + '</option>' +
        list.map(function (r) {
          return '<option value="' + esc(r[0]) + '"' + (current && current === r[0] ? ' selected' : '') + '>' + esc(ar ? r[1] : r[0]) + '</option>';
        }).join('') +
        (z ? '<option value="__other"' + (current === '__other' ? ' selected' : '') + '>' + T.other + '</option>' : '');
    }

    commitNew() {
      var other = this.areaSel.value === '__other';
      var p = { mode: 'new', zone: this.zoneSel.value, city: other ? '' : this.areaSel.value, other: other };
      save(p);
      this.syncMode(p);
      if (p.zone) this.push(p);
    }

    push(p) {
      var hint = this.querySelector('[data-da-hint]');
      apply(p).then(function () { if (hint && isComplete(p)) hint.textContent = T.saved; }).catch(function () {});
    }
  }
  DeliveryArea.count = 0;
  if (!customElements.get('delivery-area')) customElements.define('delivery-area', DeliveryArea);

  // "Buy now" on a product page lands here as /cart?buy_now=1: go straight on
  // to checkout when a delivery choice is already complete, otherwise point
  // the shopper at the box.
  if (/[?&]buy_now=1/.test(location.search)) {
    try { history.replaceState(null, '', location.pathname); } catch (e) {}
    window.addEventListener('load', function () {
      setTimeout(function () {
        var btn = document.querySelector('main button[name="checkout"]') || document.querySelector('button[name="checkout"]');
        if (btn) btn.click();   // the submit guard below either continues or highlights the box
      }, 400);
    });
  }

  // Required before checkout, and re-applied right before it (the cart and its
  // token may have changed since the choice was made).
  document.addEventListener('submit', function (e) {
    var form = e.target;
    var btn = e.submitter;
    if (!btn || btn.name !== 'checkout' || form.dataset.daDone) return;
    var pick = load();
    if (!isComplete(pick)) {
      e.preventDefault();
      e.stopImmediatePropagation();
      var scope = form.closest('.drawer, .cart-summary-card, aside, main') || document;
      var visible = function (root) { return Array.prototype.filter.call(root.querySelectorAll('delivery-area'), function (x) { return x.offsetParent; })[0]; };
      var box = visible(scope) || visible(document);
      if (box) {
        box.classList.add('is-invalid');
        var hint = box.querySelector('[data-da-hint]');
        if (hint) hint.textContent = T.need;
        box.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var target = box.newBox && !box.newBox.hidden ? (!box.zoneSel.value ? box.zoneSel : box.areaSel) : box.querySelector('input[name="' + box.group + '"]');
        if (target) setTimeout(function () { target.focus(); }, 300);
      }
      return;
    }
    e.preventDefault();
    var go = function () { form.dataset.daDone = '1'; btn.click(); };
    Promise.race([apply(pick), new Promise(function (r) { setTimeout(r, 2500); })]).then(go, go);
  }, true);
})();
